import { jsx as _jsx } from "react/jsx-runtime";
import { ImageStoreProvider } from '../Image/image.store';
import { execAfterUserInteraction } from '../../lib/idle.lib';
import { reapply } from '../../system';
import { useEffect } from 'react';
export const UIAppProvider = ({ imageConfig, disableStyleReapply, children }) => {
    useEffect(() => {
        if (disableStyleReapply) {
            return;
        }
        execAfterUserInteraction(() => {
            reapply();
        }, 5000);
    }, [disableStyleReapply]);
    return (_jsx(ImageStoreProvider, { initialState: imageConfig, children: children }));
};
